export const ANDROID_PACKAGE = 'com.kidstrail.app';
export const APP_STORE_URL = 'https://apps.apple.com/app/id6749541872';
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
export const APP_LINK_BASE = 'https://kidstrail.net/app';

export const detectPlatform = (userAgent = '', maxTouchPoints = 0) => {
  if (/android/i.test(userAgent)) return 'android';
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios';
  if (/macintosh|mac os x/i.test(userAgent) && maxTouchPoints > 1) return 'ios';
  return 'desktop';
};

export const buildPlayStoreUrl = (query = '') => {
  const params = new URLSearchParams({ id: ANDROID_PACKAGE });
  if (query) params.set('referrer', query);
  return `https://play.google.com/store/apps/details?${params.toString()}`;
};

// Apple has no deferred deep link, so params on the App Store URL are dropped at install time.
export const buildAppStoreUrl = (query = '') => {
  if (!query) return APP_STORE_URL;
  return `${APP_STORE_URL}?${query}`;
};

export const buildAppDeepLink = (query = '') => {
  const params = new URLSearchParams(query);
  const target = params.get('target');
  if (!target) return '';
  params.delete('target');
  const path = target.replace(/^\/+/, '');
  const rest = params.toString();
  if (!rest) return `${APP_LINK_BASE}/${path}`;
  return `${APP_LINK_BASE}/${path}?${rest}`;
};
